module.exports = __webpack_public_path__ + "static/img/p-13.2d666e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-13.png
// module id = 4cdG
// module chunks = 0